import React from "react";
import * as Scrivito from "scrivito";

import { TabCard } from "components/InputCards/TabCard";

import { useTranslate } from "hooks";
import { ImageDropdown } from "./ImageDropdown";
import Product3DModel from "./Product3DModel";

export const ImageTabs = Scrivito.connect(({ images, requestParams = {} }) => {
  const translate = useTranslate();
  const media = <ImageDropdown images={images} hasNoInputProd={true} />;
  const productModel = (
    <Product3DModel requestParams={requestParams} hasNoInputProd={true} />
  );

  return (
    <TabCard
      className="m-0"
      tabs={[
        translate("PRODUCT_CONFIGURATOR_MEDIA"),
        translate("PRODUCT_CONFIGURATOR_3D"),
      ]}
      container={[media, productModel]}
      hasNoInputProd={true}
    />
  );
});
